function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FormItemWrapper from './form-item-wrapper';
import emitter from '@/utils/emitter';
import i18n, { translate } from '@/utils/i18n';
import { deepClone, evalFn } from '@/utils/util';
import fieldMixin from '@/components/form-designer/form-widget/field-widget/fieldMixin';
export default {
  name: 'image-widget',
  componentName: 'FieldWidget',
  //必须固定为FieldWidget，用于接收父级组件的broadcast事件
  mixins: [emitter, fieldMixin, i18n],
  props: {
    field: Object,
    parentWidget: Object,
    parentList: Array,
    indexOfParentList: Number,
    designer: Object,
    designState: {
      type: Boolean,
      default: false
    },
    subFormRowIndex: {
      /* 子表单组件行索引，从0开始计数 */type: Number,
      default: -1
    },
    subFormColIndex: {
      /* 子表单组件列索引，从0开始计数 */type: Number,
      default: -1
    },
    subFormRowId: {
      /* 子表单组件行Id，唯一id且不可变 */type: String,
      default: ''
    }
  },
  components: {
    FormItemWrapper: FormItemWrapper,
    uploadPicture: function uploadPicture() {
      return import('@/components/uploadPicture/index');
    },
    ElImageViewer: function ElImageViewer() {
      return import('element-ui/packages/image/src/image-viewer');
    }
  },
  inject: ['refList', 'formConfig', 'globalOptionData', 'globalModel'],
  data: function data() {
    return {
      oldFieldValue: null,
      //field组件change之前的值
      fieldModel: [],
      rules: [],
      dialogVisible: false,
      isImage: false,
      srcList: [],
      uploadHeaders: {},
      uploadData: {
        key: '' //七牛云上传文件名
        //token: '',  //七牛云上传token

        //policy: '',  //又拍云上传policy
        //authorization: '',  //又拍云上传签名
      },
      fileList: [],
      //上传文件列表
      uploadBtnHidden: false,
      previewUrl: '',
      showPreviewDialogFlag: false
    };
  },
  computed: {
    realUploadURL: function realUploadURL() {
      var uploadURL = this.field.options.uploadURL;
      if (!!uploadURL && (uploadURL.indexOf('DSV.') > -1 || uploadURL.indexOf('DSV[') > -1)) {
        var DSV = this.getGlobalDsv();
        console.log('test DSV: ', DSV); //防止DSV被打包工具优化！！！
        return evalFn(this.field.options.uploadURL, DSV);
      }
      return this.field.options.uploadURL;
    }
  },
  beforeCreate: function beforeCreate() {
    /* 这里不能访问方法和属性！！ */
  },
  created: function created() {
    /* 注意：子组件mounted在父组件created之后、父组件mounted之前触发，故子组件mounted需要用到的prop
         需要在父组件created中初始化！！ */
    this.initFieldModel();
    this.registerToRefList();
    this.initEventHandler();
    this.buildFieldRules();
    this.handleOnCreated();
  },
  mounted: function mounted() {
    this.handleOnMounted();
  },
  beforeDestroy: function beforeDestroy() {
    this.unregisterFromRefList();
  },
  methods: {
    handlePictureCardPreview: function handlePictureCardPreview(i) {
      this.srcList.push(this.fieldModel[i].url);
      this.isImage = true;
    },
    handleAvatar: function handleAvatar(index) {
      this.fieldModel.splice(index, 1);
    },
    closeImageViewer: function closeImageViewer() {
      this.isImage = false;
      this.srcList = [];
    },
    beforeUpload: function beforeUpload() {
      this.dialogVisible = true;
      var imgFile = this.fieldModel.map(function (item) {
        return {
          att_size: item.size,
          real_name: item.name,
          att_dir: item.url
        };
      });
      // setTimeout(() => {
      // this.$refs.uploadPicture.checkPicList = imgFile
      // }, 300)
    },
    getImage: function getImage(data) {
      var imgFile = data.map(function (item) {
        return {
          size: item.att_size,
          name: item.real_name,
          url: item.att_dir
        };
      });
      this.fieldModel = [].concat(_toConsumableArray(this.fieldModel), _toConsumableArray(imgFile));
      this.handleClose();
      var oldValue = deepClone(this.fieldModel);
      this.syncUpdateFormModel(this.fieldModel);
      this.emitFieldDataChange(this.fieldModel, oldValue);
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
      this.$refs.uploadPicture.getFileList('');
      this.$refs.uploadPicture.selectItem = [];
      this.$refs.uploadPicture.checkPicList = [];
    },
    handlePictureExceed: function handlePictureExceed() {
      var uploadLimit = this.field.options.limit;
      this.$message.warning(this.i18nt('render.hint.uploadExceed').replace('${uploadLimit}', uploadLimit));
    },
    handlePicturePreview: function handlePicturePreview(file) {
      this.previewUrl = file.url;
      this.showPreviewDialogFlag = true;
    },
    beforePictureUpload: function beforePictureUpload(file) {
      var fileTypeCheckResult = false;
      if (!!this.field.options && !!this.field.options.fileTypes) {
        var uploadFileTypes = this.field.options.fileTypes;
        if (uploadFileTypes.length > 0) {
          fileTypeCheckResult = uploadFileTypes.some(function (ft) {
            return file.type === 'image/' + ft;
          });
        }
      }
      if (!fileTypeCheckResult) {
        this.$message.error(this.i18nt('render.hint.unsupportedFileType') + file.type);
        return false;
      }
      var fileSizeCheckResult = false;
      var uploadFileMaxSize = 5; //5MB
      if (!!this.field.options && !!this.field.options.fileMaxSize) {
        uploadFileMaxSize = this.field.options.fileMaxSize;
      }
      fileSizeCheckResult = file.size / 1024 / 1024 <= uploadFileMaxSize;
      if (!fileSizeCheckResult) {
        this.$message.error(this.i18nt('render.hint.fileSizeExceed') + uploadFileMaxSize + 'MB');
        return false;
      }
      this.uploadData.key = file.name;
      return this.handleOnBeforeUpload(file);
    },
    handleOnBeforeUpload: function handleOnBeforeUpload(file) {
      if (!!this.field.options.onBeforeUpload) {
        var bfFunc = new Function('file', this.field.options.onBeforeUpload);
        var result = bfFunc.call(this, file);
        if (typeof result === 'boolean') {
          return result;
        } else {
          return true;
        }
      }
      return true;
    },
    updateFieldModelAndEmitDataChangeForUpload: function updateFieldModelAndEmitDataChangeForUpload(fileList, customResult, defaultResult) {
      var oldValue = deepClone(this.fieldModel);
      if (!!customResult && !!customResult.name && !!customResult.url) {
        this.fieldModel.push({
          name: customResult.name,
          url: customResult.url
        });
      } else if (!!defaultResult && !!defaultResult.name && !!defaultResult.url) {
        this.fieldModel.push({
          name: defaultResult.name,
          url: defaultResult.url
        });
      } else {
        this.fieldModel = deepClone(fileList);
      }
      this.syncUpdateFormModel(this.fieldModel);
      this.emitFieldDataChange(this.fieldModel, oldValue);
    },
    handlePictureUpload: function handlePictureUpload(res, file, fileList) {
      if (file.status === 'success') {
        var customResult = null;
        if (!!this.field.options.onUploadSuccess) {
          var customFn = new Function('result', 'file', 'fileList', this.field.options.onUploadSuccess);
          customResult = customFn.call(this, res, file, fileList);
        }
        this.updateFieldModelAndEmitDataChangeForUpload(fileList, customResult, res);
        this.fileList = deepClone(fileList);
        this.uploadBtnHidden = fileList.length >= this.field.options.limit;
      }
    },
    updateFieldModelAndEmitDataChangeForRemove: function updateFieldModelAndEmitDataChangeForRemove(file, fileList) {
      var oldValue = deepClone(this.fieldModel);
      var foundFileIdx = -1;
      this.fileList.map(function (fi, idx) {
        if (fi.name === file.name && (fi.url === file.url || !!fi.uid && fi.uid === file.uid)) {
          /* 这个判断有问题？？ */
          foundFileIdx = idx;
        }
      });
      if (foundFileIdx > -1) {
        this.fieldModel.splice(foundFileIdx, 1);
      }
      this.syncUpdateFormModel(this.fieldModel);
      this.emitFieldDataChange(this.fieldModel, oldValue);
    },
    handlePictureRemove: function handlePictureRemove(file, fileList) {
      this.updateFieldModelAndEmitDataChangeForRemove(file, fileList);
      this.fileList = deepClone(fileList); //this.fileList = fileList
      this.uploadBtnHidden = fileList.length >= this.field.options.limit;
      if (!!this.field.options.onFileRemove) {
        var customFn = new Function('file', 'fileList', this.field.options.onFileRemove);
        customFn.call(this, file, fileList);
      }
    },
    handleUploadError: function handleUploadError(err, file, fileList) {
      if (!!this.field.options.onUploadError) {
        var customFn = new Function('error', 'file', 'fileList', this.field.options.onUploadError);
        customFn.call(this, err, file, fileList);
      } else {
        this.$message({
          message: this.i18nt('render.hint.uploadError') + err,
          duration: 3000,
          type: 'error'
        });
      }
    }
  }
};